<template>
  <v-container fluid>
    <v-col class="justify-center align-center">
      <v-row align="center" justify="center">
        <a href="https://rossinienergy.com" target="_blank">
          <img src="/src/assets/logo_hor_re.png" class="logo" alt="RossiniEnergy logo"/>
        </a>
      </v-row>
      <v-row align="center" justify="center">
        <v-card style="width: 400px">
          <v-card-title>
            <h1 style="text-align: center;font-size: 36px">Super Admin</h1>
          </v-card-title>
          <v-card-text>
            <v-form @submit.prevent="loginUser">
              <v-text-field label="Username" v-model="username" type="username" required></v-text-field>
              <v-text-field label="Password" v-model="password" type="password" required></v-text-field>
              <v-btn type="submit" color="primary">Login</v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-row>
    </v-col>
  </v-container>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useAuthStore } from '../store/authstore';
import { useRoute, useRouter } from "vue-router";

const authStore = useAuthStore();
const route = useRoute();
const router = useRouter();


const username = ref('');
const password = ref('');

async function loginUser() {
  return authStore.login(username.value, password.value).catch(error => alert(error));
}

onMounted(() => {
  if (authStore.isLogged(route)) {
    router.push('/');
  }
});
</script>

<style scoped>
.logo {
  height: 6em;
  padding: 1.5em;
  will-change: filter;
  transition: filter 300ms;
}

.logo:hover {
  filter: drop-shadow(0 0 2em #E93F37);
}
</style>
